'use strict';

import { keyBy, uniqBy, sortBy, intersection } from "lodash"
import {responseCreated, ADVANCED_SEARCH_OPTIONS, SORT_FIELD_OPTIONS, SORT_ORDER_OPTIONS, RECOMMENDATION_OPTIONS} from './ReviewsTabData';
import {STATES} from '../../common/data/uiData'
import _ from "lodash"
import FeaturesStore from '../../modules/app/FeaturesStore'
import presignedExport from '../../services/auth/presignedExport'
import * as pulseApi from '../../modules/pulse/api'
import reviewFiltersStore, { reports, ratings, dateRanges, singleReviewFiltersStore } from "../../modules/reviews/ReviewFilterStore";
import ProvidersStore from "../../services/providers/ProvidersStore";
import { bindReviewFiltersAndSelectedLocationToAngular, bindSingleReviewFiltersAndSelectedLocationToAngular } from "./filterBindingUtils";
import { pushToUrl, FieldDescriptors } from '../../util/urlSync';
import api from "../../../src/modules/reviews/api";

const states = STATES;

let moment = require('moment');
let initialScope = {
  reports: reports,
  topicEditor: {
    setId: null,
    isOpen : {},
    keyedTrackedTopics : {},
    trackedTopics: [],
    selectedTopic : false,
    selectedPrimaryTopic : false,
    state: states.init
  },
  defaultUserPic: '/images/man-default.png',
  reviewSearchOptions: {limit: 20, sortField: "reviewDate", sortOrder: "DESC" },
  storeComparisonOptions: {limit: 20, sortField: "count", sortOrder: "DESC"},
  locationSummaries: {},
  loadingResults: true,
  infiniteScrollLoading: false,
  initializing: true,
  reviews: [],
  totalResults: 0,
  hasMore: null,
  tagSettings: {
    selectedTag: "",
    state: states.init
  },
  reviewTags: [],
  states: states,
  onlyYelpReviewsVisible: false,
}

const mod = angular.module('clientDashboardApp');

mod.controller("ReviewCtrl",
  function (
    $scope,
    $uibModal,
    reviewService,
    reviewResponseConfiguration,
    locationService,
    $location,
    configService,
    customProvidersService,
    reviewResponseTemplateService,
    $timeout,
    $log,
    reactContainer
    ) {
    /*************************** Scoped constants and variables ******************************/

    $scope.showDownload = true;
    angular.merge($scope, initialScope);

    $scope.initialLoad = true;
    $scope.tagsFromReviews = [];

    $scope.providers = ProvidersStore.reviewProviders;
    $scope.customProviders = {};
    customProvidersService.getContentProvidersWithChildAccounts().then(resp => {
      $scope.customProviders = keyBy(resp.data.contentProviders, x => x.name)
    });

    $scope.FILTER_OPTIONS = {
      ADVANCED_SEARCH: ADVANCED_SEARCH_OPTIONS,
      SORT_FIELD: SORT_FIELD_OPTIONS,
      SORT_ORDER: SORT_ORDER_OPTIONS,
    };

    $scope.filterState = {
      advancedSearch: [],
      sortField: _.find(SORT_FIELD_OPTIONS,{value:"reviewDate"}),
      sortOrder: _.find(SORT_ORDER_OPTIONS,{value:"DESC"})
    };

    $scope.allRatings = ratings.concat(RECOMMENDATION_OPTIONS)

    $scope.noteSettings = {
      usingTable: true,
      colOffset: 1,
      idKey: "reviewId",
      noteType: "review",
      userInfo: $scope.userInfo,
      ready: 0
    };

    refreshReviewResponseTemplates();
    $scope.searchConfig = {
      report: reports.find(x => x.reportType === "summary")
    }; // copy mobx to angular so angular binding works
    if(reactContainer.getContainer().singleReview){
      bindSingleReviewFiltersAndSelectedLocationToAngular($scope, $scope.searchConfig);
    } else {
      bindReviewFiltersAndSelectedLocationToAngular($scope, $scope.searchConfig);
      
      // Review list no longer has any knowledge of reviewId, but this removes it from the URL
      // to avoid confusing users
      pushToUrl(reviewFiltersStore.state, FieldDescriptors.build({
        reviewId: undefined
      }));
    }

    /*************************** Scoped methods ******************************/

    $scope.setReviewTags = (tags) => {
      $scope.reviewTags = $scope.sortTags(tags);
    }

    configService.getBrandConfig(false, false).then(function (brandConfig) {
      $scope.brandConfig = brandConfig;
      $scope.updateTagsForAccount();
      $scope.setReviewTags(uniqBy($scope.reviewTags.concat([], $scope.brandConfig.reviewTags.map((item) => ({name:item.name,id:item._id.$oid}))),"id"));
    });

    $scope.updateTagsForAccount = function() {
      $scope.tagsForAccount = $scope.brandConfig.reviewTags.map((item) => ({name:item.name,id:item._id.$oid}))
      $scope.tagsForAccount = sortBy($scope.tagsForAccount, ['name']);
    }

    $scope.openManageResponseTemplatesModal = () => {
      const modal = $uibModal.open({
        template: require('./responseTemplates/templatesList.html'),
        controller: 'ReviewResponseTemplateCtrl',
        size: 'lg'
      })
      modal.closed.then(function() {
        refreshReviewResponseTemplates()
      })
    }

    $scope.openTagEditor = (review) => {
      review.tagReviewOpen = true;
      $scope.tagSettings.state = states.init
    }

    $scope.selectManagedPage = function(page) {
      $scope.fbUserInfo.pageId = page.id;
      $scope.selectedManagedPage = page;
    }

    $scope.qualifyURL = function(url) {
      var a = document.createElement('a');
      a.href = url;
      return a.href;
    }

    $scope.userHasPermission = function(permission) {
      return $scope.userInfo ? $scope.userInfo.permissions.indexOf(permission) !== -1 : false
    }

    $scope.showingMultipleLocations = (review) => {
      return review.locationId && $scope.locationSummaries[review.locationId] && Object.keys($scope.locationSummaries).length > 1
    }

    $scope.checkAndExecuteSearch = function (isFormValid) {
      if (isFormValid) {
        executeSearch();
      }
    }

    $scope.markResultsLoaded = function() {
      $scope.loadingResults = false
    }

    $scope.syndCollapsed = {};

    $scope.scrollToReviews = function() {
      $location.hash('reviews-list')
    }

    $scope.topicEditor.topicClassifications = {}

    $scope.loadSentimentData = () => {

      if ($scope.brandConfig.restrictions.hideSentiment) return;

      const reviewHash = {}
      for (let r of $scope.reviews) {
        reviewHash[r.reviewId] = r
      }

      return pulseApi.getReviewTopics({ reviewIds: Object.keys(reviewHash) }).then(reviewTopics => {
        for (let {reviewId, topics} of reviewTopics) {
          let review = reviewHash[reviewId]
          if (review) {
            review.sentimentResult = {score: {classification: "Positive"}, topics: topics};
          }
        }
        $scope.$apply()
      });

    }

    $scope.ignoreReviewPopup = function (reviewId) {
      var ModalInstanceCtrl = ['$scope', '$uibModalInstance', 'reviewService', function ($scope, $uibModalInstance, reviewService) {
        var states = {
          new: 'new',
          pending: 'pending',
          complete: 'complete',
          failed: 'failed'
        };

        $scope.state = states.new;
        $scope.submitted = false;

        $scope.ignore = function () {
          $scope.submitted = true;
          $scope.state = states.pending;
          reviewService.markReviewNotMine(reviewId).then(function () {
            $scope.state = states.complete;

          }, function () {
            $scope.state = states.failed;
          });

        };

        $scope.close = function () {
          $uibModalInstance.dismiss('close');
        };

        $scope.$watch('state',function(newVal,oldVal){
          updateParentState(newVal)
        })

        function updateParentState(state) {
          $scope.$parent.ignoreReviewState = state;
        }

      }];

      var modalInstance = $uibModal.open({
        template: require('./ignoreReviewModal.html'),
        controller: ModalInstanceCtrl
      });

      modalInstance.result.then(function () {
        $log.info('Modal dismissed at: ' + new Date());
      }, function(){
        if($scope.ignoreReviewState=='complete'){
          refreshReviews();
        }
      });

      const refreshReviews = () => {
        $scope.checkAndExecuteSearch(true);
      }
    }

    $scope.getSortIcon = function (column) {
      if ($scope.reviewSearchOptions.sortField === column) {
        if ($scope.reviewSearchOptions.sortOrder === 'ASC') {
          return 'fa-sort-up';
        } else {
          return 'fa-sort-down';
        }
      } else {
        return 'fa-sort';
      }
    };

    $scope.getResponseUserTitle = function(response){
      if (response.userTitle) {
        return response.userTitle;
      } else {
        return "Business Owner";
      }
    };

    $scope.sortReviewsTable = function () {
      $scope.reviewSearchOptions.sortField = $scope.filterState.sortField.value;
      $scope.reviewSearchOptions.sortOrder = $scope.filterState.sortOrder.value;

      $scope.loadingReviewDetails = true;
      $scope.reviewSearchOptions.offset = 0;
      reviewService.search($scope.reviewSearchOptions).then(response => {
        $scope.reviews = [];
        $scope.totalResults = 0;
        updateReviewsTable(response, $scope.reviewSearchOptions);
      });
    };

    $scope.hasMoreResults = function (searchResult) {
      if (!searchResult) {
        return;
      }
      return $scope.hasMore !== false;
    };

    $scope.hasAnyResults = function () {
      return reviews.length > 0
    };

    $scope.loadMoreResults = function() {
      if ($scope.loadingResults || $scope.loadingReviewDetails || $scope.hasMore === false) {
        return;
      }
      $scope.loadingReviewDetails = true;
      $scope.infiniteScrollLoading = true;

      reviewService
        .search($scope.reviewSearchOptions)
        .then(response => { updateReviewsTable(response, $scope.reviewSearchOptions); return response })
    };

    $scope.getReviewClass = function(review){
      if(review.responses.length){
        return "hasOwnerResponse";
      }
    };

    $scope.hasError = function(el) {
      if((el.$error.required || el.$error.maxlength ) && el.$dirty ){
        return true;
      }
    }

    $scope.reviewDeepLinked = () => {
      const isDeepLinked = !!($scope.searchConfig && $scope.searchConfig.reviewId);
      return isDeepLinked;
    }

    $scope.workflow2Disabled = !FeaturesStore.workflow2Enabled


    /****************** Non-scoped methods *********************/




    window.toggleDoNotUseReviewSummaries = () => {
      console.log("do not use summaries: " + ($scope.searchConfig.doNotUseSummaries = !$scope.searchConfig.doNotUseSummaries));
      executeSearch();
    };

    $scope.defaultTemplate = {name: "Add blank template", body: ""}

    function refreshReviewResponseTemplates() {
      reviewResponseTemplateService.listTemplates().then((templates) => {
        /*Refresh templates for single-response*/
        $scope.reviewResponseTemplates = templates

        /*Refresh templates for bulk-response*/
        $scope.responseTemplates = [{...$scope.defaultTemplate}].concat(templates)
        $scope.groupedResponseTemplates = _.groupBy($scope.responseTemplates,'reviewSentimentType')
        $scope.selectedResponseTemplate = $scope.responseTemplates[0]
        $scope.loadingTemplates = false
      })
    }

    // set this to a time in the future to prevent search from being queried for a bit (e.g. if the user
    // is trying to select options in a menu
    let searchBackoff = moment().subtract(1, "hour");
    // if searchBackoff is set, a specific debounce time can be scheduled, otherwise use the min
    function extendableWait() {
      const min = 500;
      const remaining = searchBackoff.diff(moment(), "ms");
      return Math.max(min, remaining);
    }
    /**
     * This is the primary function that should be called to update search results if the input is from the UI
     * e.g. from changing filters. It schedules the review search to be executed in the future (usually 250ms).
     * Repeat calls will extend the execution.
     * */
    function executeSearch() {
      $timeout(() => {
        // set loading variables to true "immediately" so loading view doesn't appear laggy
        // running in a $timeout to not have to fuss with whether or not we're in an angular digest cycle
        $scope.loadingResults = true;
        $scope.loadingReviewDetails = true;
      }, 0);
      loadContentDebounced();
    }
    const loadContentDebounced = variableWaitDebounce(loadContent, extendableWait);

    /** temporarily increase the debounce before a search is executed to the specified duration
     * Can also decrease the timeout, but only if called before an executeSearch() invocation is called
     * (does not interrupt existing scheduled invocations) */
    $scope.setDebounce = (ms = 1000) => {
      searchBackoff = moment().add(ms, "ms");
    };

    /** schedules search to be executed (debounced) ms milliseconds in the future */
    $scope.scheduleSearchExecution = (ms = 1000) => {
      $scope.setDebounce(ms);
      executeSearch();
    }
    /** This function updates state to loading, and fetches results from current filters immediately */
    function loadContent() {
      $scope.loadingResults = true;

      //clear inclusion parameters
      ADVANCED_SEARCH_OPTIONS.map(option => {
        delete $scope.reviewSearchOptions[option.parameterName]
      });

      const filter = {};
      filter.groupId = $scope.searchConfig.groupId;
      filter.doNotUseSummaries = $scope.searchConfig.doNotUseSummaries;
      $scope.reviewSearchOptions.startDate = null;
      $scope.reviewSearchOptions.endDate = null;
      $scope.reviewSearchOptions.providers = null;
      $scope.reviewSearchOptions.tags = null;
      $scope.reviewSearchOptions.range = null;
      $scope.reviewSearchOptions.ratings = null;
      $scope.reviewSearchOptions.searchText = null;

      $scope.reviewSearchOptions.responsesFilter = reviewFiltersStore.state.responsesFilter;
      $scope.reviewSearchOptions.notesFilter = reviewFiltersStore.state.notesFilter;
      $scope.reviewSearchOptions.revisionsFilter = reviewFiltersStore.state.revisionsFilter;
      $scope.reviewSearchOptions.textFilter = reviewFiltersStore.state.textFilter;
      $scope.reviewSearchOptions.tagFilter = reviewFiltersStore.state.tagFilter;
      $scope.reviewSearchOptions.removedReviewsFilter = reviewFiltersStore.state.removedReviewsFilter;
      $scope.reviewSearchOptions.filteredReviewsFilter = reviewFiltersStore.state.filteredReviewsFilter;
      $scope.reviewSearchOptions.respondableReviewsFilter = reviewFiltersStore.state.respondableReviewsFilter;
      $scope.reviewSearchOptions.approvableResponseFilter = reviewFiltersStore.state.approvableResponseFilter;
      $scope.reviewSearchOptions.customerResponseFilter = reviewFiltersStore.state.customerResponseFilter;

      filter.offset = 0;

      const searchText = reviewFiltersStore.state.searchText || "";
      searchText.length > 0
        ? $scope.reviewSearchOptions.searchText = searchText
        : delete $scope.reviewSearchOptions.searchText;

      if ($scope.searchConfig.range) {
        filter.range = $scope.searchConfig.range;
      }

      if ($scope.searchConfig.providers) {
        filter.providers = $scope.searchConfig.providers.join();
      }
      if ($scope.searchConfig.tags.length) {
        filter.tags = $scope.searchConfig.tags.join();
      }

      if($scope.searchConfig.reviewId){
        filter.reviewId = $scope.searchConfig.reviewId;
      }

      if($scope.searchConfig.ratings.length){
        filter.ratings = $scope.searchConfig.ratings.join(",");
      }

      const selected = dateRanges.find(range =>
        range.to.diff(reviewFiltersStore.state.endDate, "days") === 0 &&
        range.from.diff(reviewFiltersStore.state.startDate, "days") === 0
      );

      filter.reportRange = !!selected && selected.id !== "LastDay" ? selected.id : "SpecificDates";

      if (reviewFiltersStore.state.startDate && filter.reportRange !== "AllTime") {
        filter.startDate = moment(reviewFiltersStore.state.startDate).format("YYYY-MM-DD");
      }

      if (reviewFiltersStore.state.endDate && filter.reportRange !== "AllTime") {
        filter.endDate = moment(reviewFiltersStore.state.endDate).format("YYYY-MM-DD");
      }

      // If AdvancedFilter filteredReviews options not specificed, default to not showing filtered reviews. See SUDO-431
      if($scope.reviewSearchOptions.filteredReviewsFilter === undefined) {
        $scope.reviewSearchOptions.filteredReviewsFilter = "onlyWithout";
      }

      locationService.getLocationsInGroup($scope.searchConfig.groupId).then(
        locationMap => {
          $scope.locationSummaries = {};
          for (let [id, location] of Object.entries(locationMap)) {
            const clientLocationId = !!location.locationIdForDisplay ? location.locationIdForDisplay : !!location.resellerLocId && location.resellerLocId;
            $scope.locationSummaries[id] = locationService.formatLocation(location).summary + (!!clientLocationId && clientLocationId !== "" && !$scope.brandConfig.restrictions.hideClientLocationId ? ` (${clientLocationId})` : "")
          }
        }
      )

      $scope.reportType = $scope.searchConfig.report;
      if ($scope.searchConfig.report.reportType === 'summary') {
        angular.extend($scope.reviewSearchOptions, filter);
        $scope.loadingReviewDetails = true;
        if(reactContainer.getContainer().singleReview) {
          api.getReviewsById([$scope.reviewSearchOptions.reviewId]).then(response => {
            const data = response[0];
            // Response data has different keys for sinlge or multiple reviews :(
            const transformedResponse = {results: [{
              ...data,
              _id: {
                $oid: data._id
              }
            }]};
            $scope.reviews=[];
            updateReviewsTable(transformedResponse, $scope.reviewSearchOptions)
            return response;
          });
        } else {
          reviewService.search($scope.reviewSearchOptions).then(response => {
            $scope.reviews=[];
            updateReviewsTable(response, $scope.reviewSearchOptions)
            return response;
          });
        }
      }
    }

    $scope.preparingExport = false
    $scope.exportReviews = function() {
      $scope.preparingExport = true
      presignedExport.downloadExport("/v5/reviews/export", $scope.reviewSearchOptions)
      $timeout(() => $scope.preparingExport = false, 10000)
    }

    function updateSearchResults(searchResponse) {
      $scope.searchResults = searchResponse;
      $scope.initialLoad = false;
    }

    function updateReviewsTable(searchResponse, filters) {
      $scope.reviewSearchOptions.offset += searchResponse.results.length;
      $scope.hasMore = searchResponse.cursor != 0;
      _.each(searchResponse.results, function (item) {
        item.lastRevised = $scope.formatDate(item.lastRevisionDate.$date)
        if (item.responses) {
          // BEGIN - quick temporary solution to prevent duplicated responses breaking rendering
          let responseDictionary = {};
          let distinctResponse = [];
          item.responses.forEach(response => {
            if(!responseDictionary[response._id.$oid]){
              responseDictionary[response._id.$oid] = response;
              distinctResponse.push(response);
            }
          });
          item.responses = distinctResponse;
          // END

          _.each(item.responses, response => response.dateObj = response.date.$date)
        }
        locationService.locationSummary(item.locationId).then(function (location) {
          $scope.locationSummaries['legacy-' + location.locationId] = location.summary;
        });
        if (item.previousRevisions.length > 0) {
          item.revisedOn = $scope.formatDate(item.previousRevisions[0].revisedOn)
          item.previousRating = item.previousRevisions[0].previousState.rating
          _.each(item.previousRevisions, (pre) => {
            pre.revisedOn = $scope.formatDate(pre.revisedOn)
          })
        }
        if (item.reviewTags.length) {
          $scope.tagsFromReviews = $scope.tagsFromReviews.concat(item.reviewTags.map((tagObject) => ({name:tagObject.name,id:tagObject._id.$oid})))
        }
      });

      $scope.tagsFromReviews = uniqBy($scope.tagsFromReviews,"id")
      $scope.setReviewTags(uniqBy($scope.reviewTags.concat($scope.tagsFromReviews),"id"))

      _.each(_.filter(searchResponse.results, function(toFilter){ return toFilter.syndicatedReviews}),function(item){
        $scope.syndCollapsed[item.reviewId] = true;
      });

      var syndRevsToHide = _.filter(searchResponse.results, item => {
        if (filters.responsesFilter === "OnlyWithout") {
          return !!item.originalContentProvider
            && isProviderIncludedInSearch(item.originalContentProvider) && isOriginalReviewPresent(item, searchResponse.results)
        } else {
          return !!item.originalContentProvider
            && isProviderIncludedInSearch(item.originalContentProvider)
            && isOriginalReviewPresent(item, searchResponse.results)
        }
      });
      $scope.syndicatedReviews = syndRevsToHide;
      $scope.totalResults = searchResponse.totalResults;
      searchResponse.results = _.difference(searchResponse.results,syndRevsToHide);
      const allReviewIds = new Set($scope.reviews.map(x => x.reviewId))

      const additions = searchResponse.results.filter(r => {
        // Remove duplicates if present.
        const had = allReviewIds.has(r.reviewId)
        if (!had) {
          allReviewIds.add(r.reviewId)
        }
        return !had
      })
        .map(review => {
          // review.canRespond - Can a user respond to this review (used in child controllers)
          review.canRespond = reviewResponseConfiguration.isResponseAllowed(review);
          review.canRespondBulk = reviewResponseConfiguration.isBulkResponseAllowed(review);
          review.canRespondBulkFalseyMessage = reviewResponseConfiguration.forProvider(review.contentProvider)['canRespondBulkFalseyMessage'];
          return review
        });

      /**
       * angular is really slow... this is a dumb hack to incrementally add reviews to not overwhelm it's rendering
       * and have some reviews visible to the user sooner
       * (api calls are many times faster than the rendering)
       */
      function appendAsync(quantity = 10) {
        const toAdd = additions.splice(0, quantity)
        $scope.reviews.push(...toAdd);

        if (additions.length) {
          $timeout(() => appendAsync(quantity * 2), 20)
        } else { // done, finalize
          $scope.reviewExportToken = {
            'export': () => {
              let exportFilters = angular.copy(filters);
              delete exportFilters.limit;
              delete exportFilters.offset;
              return reviewService.exportReviews(exportFilters);
            },
            totalResults: searchResponse.totalResults
          }

          $scope.loadSentimentData();

          $scope.loadingReviewDetails = false;
          $scope.infiniteScrollLoading = false;
          $scope.initialLoad = false;
          $scope.loadingResults = false;
          $scope.noteSettings.ready += 1;

          $scope.onlyYelpReviewsVisible = $scope.reviews.length > 0 && $scope.reviews.map(x => x.contentProvider).find(provider => !["YELP", "YELPGB", "YELPCA"].includes(provider)) === undefined
        }
      }

      appendAsync()
    }

    $scope.sortTags = (tags) => {
      return tags.sort(function(a, b){
        if(a.name.toLowerCase() < b.name.toLowerCase()) return -1;
        if(a.name.toLowerCase() > b.name.toLowerCase()) return 1;
        return 0;
      })
    }

    function isProviderIncludedInSearch(provider){
      return $scope.searchConfig.providers.indexOf(provider) >= 0 || $scope.searchConfig.providers.length === 0;
    }

    function isOriginalReviewPresent(review, newResults) {
      let isDifferentReview = (review1, review2) => review1._id !== review2._id;
      let hasSameOriginalReview = (review1, review2) =>
      (review1.providerReviewId && review1.providerReviewId === review2.providerReviewId)
      || review1.reviewDetail === review2.reviewDetail

      function containsTrunc(review1, review2) {
        let answer = false
        const truncationMarkers=["... Read more", " Read more", "…", "... more"]
        const truncMark = truncationMarkers.find(marker => review1.reviewDetail && review1.reviewDetail.endsWith(marker))
        if (truncMark) {
          const endingPoint = review1.reviewDetail.indexOf(truncMark)
          const truncatedReview = review1.reviewDetail.substr(0, endingPoint)
          answer = review2.reviewDetail && review2.reviewDetail.startsWith(truncatedReview)
        }
        return answer;
      }

      let sameOriginalButTruncated = (review1, review2) => {
        let answer = containsTrunc(review1, review2) || containsTrunc(review2,review1)
        return answer
      }

      let matchingOriginal=_.find($scope.reviews.concat(newResults), otherReview => {
        return isDifferentReview(review, otherReview) &&
          (hasSameOriginalReview(review, otherReview) || sameOriginalButTruncated(review,otherReview))
      })

      //If matchingOriginal is undefined it means there are no matches in the list. Therefore original review is not present
      return typeof matchingOriginal !== "undefined"
    }

    $scope.formatDate = (date) => {
     return moment(date).utc().format('M/D/YY')
    }
    
    /********************** Watch and event handling ************************/


    $scope.$watch("searchConfig", function (newConfig,oldConfig) {
      if (!!newConfig && !angular.equals(newConfig.report, !!oldConfig ? oldConfig.report : {}) || !angular.equals(newConfig, oldConfig)) {
        if (!!newConfig.report && newConfig.report.reportType === 'summary') {
          executeSearch();
        }
      } else if (!$scope.searchResults && !!newConfig.report && newConfig.report.reportType === 'summary') {
        executeSearch();
      }

    }, true);

    $scope.$watch("filterState.advancedSearch", function(newVal, oldVal) {
      if (newVal !== oldVal) {
        executeSearch(true);
      }
    },1)

    executeSearch(); // initial

    /**
     * This handles breaking pagination when both of these occur:
     * - the user selected the "only reviews without responses filter
     * - the user responds to reviews on the page
     *
     * This causes reviews which have already been fetched from the api to no longer match the query, essentially decreasing the number of results which would
     * have been loaded on prior pages, so we need to decrease the search offset accordingly.
     */
    $scope.$on(responseCreated, function() {
      if (_.find($scope.filterState.advancedSearch, {tag: "responsesFilter:OnlyWithout"})) {
        $scope.reviewSearchOptions.offset -= 1
      }
    })


    $scope.$on('reviewTagReview', (event, review) => {
      let reviewHasTags = !!(review.reviewTags && review.reviewTags.length);
      let searchHasTags = !!($scope.searchConfig.tags && $scope.searchConfig.tags.length);
      let reviewTagsIds;
      if(reviewHasTags){
        reviewTagsIds = review.reviewTags.map((item) => item._id.$oid);
      }
      if((!reviewHasTags && searchHasTags) || (searchHasTags && !intersection($scope.searchConfig.tags, reviewTagsIds).length)){
        $scope.reviews.splice($scope.reviews.indexOf(review), 1)
      }
    });

  });

/**
 * like lodash debounce, https://lodash.com/docs/#debounce
 * but waitFor is a function whose duration can change according to circumstances
 * @param fn
 * @param waitFor
 * @return function that schedules fn to be executed when applied.
  */
export function variableWaitDebounce(fn, waitFor) {
  let timer;
  function debounced(...args) {
    clearTimeout(timer);
    let lastWait = waitFor();
    // run the function after waitFor ms.
    // Double checks the waitFor before running the function in case its been extended.
    // If so, function recurses the remaining duration
    function debouncedInner() {
      let nextWait = waitFor();
      if (nextWait <= lastWait) {
        fn(...args)
      } else {
        const diff = nextWait - lastWait;
        lastWait = nextWait;
        timer = setTimeout(debouncedInner, diff);
      }
    }
    timer = setTimeout(debouncedInner, lastWait);
  }
  debounced.cancel = () => clearTimeout(timer);
  return debounced
}
